/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Name_EmptyInputs */

const en_us2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should we call you?`)
};

const pt_br2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como quer ser chamado?`)
};

const es_419_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo quieres que te llamemos?`)
};

const pt_pt2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como queres ser tratado?`)
};

const fr_fr2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment veux-tu qu'on t'appelle ?`)
};

const de_de2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie sollen wir dich nennen?`)
};

const it_it2_profile_name_empty = /** @type {(inputs: Profile_Name_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vuoi essere chiamato?`)
};

/**
* | output |
* | --- |
* | "What should we call you?" |
*
* @param {Profile_Name_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_name_empty = /** @type {((inputs?: Profile_Name_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Name_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_name_empty(inputs)
	if (locale === "es-419") return es_419_profile_name_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_name_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_name_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_name_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_name_empty(inputs)
	return en_us2_profile_name_empty(inputs)
});
export { profile_name_empty as "profile.name_empty" }